<button type="buttonSettings.type" class="btn" [class.upper]="allCaps"
  [ngClass]="[buttonSettings.buttonClass, fullWidth ? 'full-width': '']" [ngStyle]="customButtonStyle"
  [disabled]="disabled || loading" (click)="onClick()">
  <i *ngIf="buttonSettings.hasIcon" class="btn-icon fa" [ngClass]="[buttonSettings.icon]" aria-hidden="true"></i>
  <span class="btn-text">{{ buttonSettings.text }}</span>
</button>
